var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._b({attrs:{"dense":""}},'v-list',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }